import { Pipe, PipeTransform } from '@angular/core';

import { contatoTipos } from '../pessoa-contato-tipo';

@Pipe({
    name: 'pessoaContatoTipoSequenciaPrimario'
})
export class PessoaContatoTipoSequenciaPrimarioPipe implements PipeTransform {
    transform(value: number): number {
        if (!value) {
            return 0;
        }

        const index = contatoTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return contatoTipos[index].sequenciaPrimario;
        }
        return 0;
    }
}
